export default class {
    _id;
    _name;
    _username;
    _postIndex;
    _type;
    _permissions;
    _regions;
    _areas;

    get id() {
        return this._id
    }

    set id(value) {
        this._id = value
    }

    get name() {
        return this._name
    }

    set name(value) {
        this._name = value
    }

    get username() {
        return this._username
    }

    set username(value) {
        this._username = value
    }

    get postIndex() {
        return this._postIndex
    }

    set postIndex(value) {
        this._postIndex = value
    }

    get type() {
        return this._type
    }

    set type(value) {
        this._type = value
    }

    get permissions() {
        return this._permissions
    }

    set permissions(value) {
        this._permissions = value
    }

    get regions() {
        return this._regions
    }

    set regions(value) {
        this._regions = value
    }

    get areas() {
        return this._areas
    }

    set areas(value) {
        this._areas = value
    }


}